import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { authCheck } from '../../services/AuthenticationService'
import ChangePasswordCard from '../../components/ChangePasswordCard'
import { makeStyles } from '@material-ui/core/styles'
import { Helmet } from 'react-helmet'
import { useIntl } from 'react-intl'

const useCustomStyles = makeStyles(() => ({
  changePasswordPage: {
    height: '100%',
    display: 'flex',
  },
}))

const ChangePasswordPage = () => {
  const classes = useCustomStyles()
  const [info, setInfo] = useState({ response: null, loading: true })
  const history = useHistory()
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: 'page_title_change', defaultMessage: 'Change password | OCLC' })

  useEffect(() => {
    const getInfo = async () => {
      setInfo({ ...info, loading: true })
      const data = await authCheck()
      setInfo({ response: data, loading: false })
    }
    getInfo()
  }, [])

  useEffect(() => {
    if (!info.loading && !info.response.name) {
      history.push('/')
    }
  }, [info.loading])

  return info.loading || !info.response.name ? null : (
    <div data-testid='eldap-change-password-page' className={classes.changePasswordPage}>
      <Helmet title={pageTitle} />
      <ChangePasswordCard />
    </div>
  )
}

export default ChangePasswordPage
